import React, { Component } from 'react';
import { useNavigate } from 'react-router-dom';

// Wrap ErrorBoundary in a function to use hooks
function ErrorBoundaryWrapper(props) {
    const navigate = useNavigate();

    return <ErrorBoundary navigate={navigate} {...props} />;
}

class ErrorBoundary extends Component {
    constructor(props) {
        super(props);
        this.state = { hasError: false };
    }

    static getDerivedStateFromError() {
        return { hasError: true };
    }

    componentDidCatch(error, errorInfo) {
        console.error('Error caught by ErrorBoundary:', error, errorInfo);
    }

    handleReload = () => {
        this.props.navigate('/home');
        window.location.reload();
    };

    render() {
        if (this.state.hasError) {
            return (
                <div style={{ padding: "7rem 3rem 3rem 3rem" }}>
                    <h2>Ups... nešto je pošlo po krivu</h2>
                    <p>
                        Klikni{' '}
                        <button
                            onClick={this.handleReload}
                            style={{
                                color: 'black',
                                textDecoration: 'underline',
                                background: 'none',
                                border: 'none',
                                cursor: 'pointer',
                                padding: 0,
                                font: 'inherit'
                            }}
                        >
                            ovdje
                        </button>{' '}
                        za ponovno učitavanje stranice.
                    </p>
                </div>
            );
        }

        return this.props.children;
    }

}

export default ErrorBoundaryWrapper;
